export default __webpack_public_path__ + "static/iconfinder_46_3319595-15dea18aeb1199ad2c6f40e7ce00562a.png";